import { render } from "./quickOrder.vue?vue&type=template&id=6b0b5dcd&scoped=true"
import script from "./quickOrder.vue?vue&type=script&lang=js"
export * from "./quickOrder.vue?vue&type=script&lang=js"

import "./quickOrder.vue?vue&type=style&index=0&id=6b0b5dcd&lang=scss&scoped=true"
import "./quickOrder.vue?vue&type=style&index=1&id=6b0b5dcd&lang=scss"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b0b5dcd"]])

export default __exports__